import { getFilledTableRows } from '@/utils/misc';
import {
  createPossessionTeamRows,
  createOffensiveTeamRows,
  createDefensiveTeamRows,
} from '@/utils/dataTablesStructures/team';
import getTeamStatPlayIndexes from '@/data/team/teamStatsPlayIndexes';
import getLeaguePlayIndexes from '@/data/leaguePlayIndexes';

/**
 * @author Alejandro
 * @description Fill all table data
 * @param {number} analysisType - Can be 1 = Possession, 2 = Offensive, 3 = Defensive
 * @param {Array} playList
 * @param {Array} leaguePlays
 * @param {Array<number>} timeSelected
 * @param {number} totalSeasonGamesOrTeams
 * @param {number} teamId
 * @return {*}
 */
export function getTeamTableData(analysisType, playList, leaguePlays, timeSelected, totalSeasonGamesOrTeams, teamId) {
  let teamDataRows = null;
  switch (analysisType) {
    case 2:
      teamDataRows = createOffensiveTeamRows();
      break;
    case 3:
      teamDataRows = createDefensiveTeamRows();
      break;
    default:
      teamDataRows = createPossessionTeamRows();
  }
  return getFilledTableRows(
    teamDataRows,
    playList,
    leaguePlays,
    timeSelected,
    totalSeasonGamesOrTeams,
    getTeamStatPlayIndexes(),
    getLeaguePlayIndexes(),
    teamId,
  );
}
